import { render, staticRenderFns } from "./bigarea.vue?vue&type=template&id=59659ceb&scoped=true&"
import script from "./bigarea.vue?vue&type=script&lang=js&"
export * from "./bigarea.vue?vue&type=script&lang=js&"
import style0 from "./bigarea.vue?vue&type=style&index=0&id=59659ceb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59659ceb",
  null
  
)

export default component.exports